import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LinkFormattingService } from '../services/link-formatting.service';

@Component({
  selector: 'sihc-quill-view',
  template: `
    <quill-view
      [modules]="modules"
      [content]="formattedContent"
      [style]="style">
    </quill-view>
  `
})
export class SihcQuillViewComponent implements OnChanges {
  @Input({ required: true }) content: string;
  @Input() modules: Record<string, unknown>;
  @Input() style: Record<string, string>;

  formattedContent = '';

  constructor(private linkFormattingService: LinkFormattingService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['content']) {
      void this.formatContent();
    }
  }

  private async formatContent(): Promise<void> {
    if (!this.content) {
      this.formattedContent = '';
      return;
    }

    this.formattedContent = this.linkFormattingService.formatHtmlLinksSync(this.content);
    this.formattedContent = await this.linkFormattingService.formatForDisplay(this.content, true);
  }
}
